import React from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { hasSelectionsUnderWarranty } from "../redux/selectors";

function ServiceSelector({
  hasSelectionsUnderWarranty
}) {
  return (
    <div className="form-group">
      <Form.Label>Service Pack</Form.Label>

      <Form.Check
        type="radio"
        checked={!hasSelectionsUnderWarranty}
        readOnly={true}
        label="Click Charge"
        id="isUnderWarranty_true"
      />

      <Form.Check
        type="radio"
        checked={hasSelectionsUnderWarranty}
        readOnly={true}
        label="Warranty"
        id="isUnderWarranty_false"
      />
    </div>
  );
}

export default connect( state => ({
    hasSelectionsUnderWarranty: hasSelectionsUnderWarranty(state)
}))(ServiceSelector);
